import store from '@/store'

export default {

  GetItems: function (externalAppLinks) {
    let items = [
      {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer',
        sortOrder: 10,
        roles: ['User', 'Admin',"PM"]
      },
      {
        name: 'Accounts',
        url: '/accounts',
        icon: 'fa fa-id-card',
        sortOrder: 20,
        roles: ['User', 'Admin', 'PM']
      },
      {
        name: 'Enterprise',
        url: '/enterprise',
        icon: 'fa fa-list-alt',
        sortOrder: 21,
        roles: ['User', 'Admin', 'PM']
      },
      {
        name: 'Accounts Audit',
        url: '/accountsaudit/',
        icon: 'fa fa-id-card',
        sortOrder: 22,
        roles: ['User', 'Admin']
      },
      {
        name: 'mDesking Lockouts',
        url: '/mdeskinglockouts',
        icon: 'fa fa-id-card',
        sortOrder: 22,
        roles: ['Admin']
      },
      {
        name: 'mDesking',
        url: externalAppLinks.mDesking,
        icon: 'fa fa-pencil-square-o',
        sortOrder: 25,
        roles: ['User', 'Admin']
      },
      {
        name: 'mPortal',
        url: externalAppLinks.mPortal,
        icon: 'fa fa-skyatlas',
        sortOrder: 26,
        roles: ['User', 'Admin']
      },
      {
        name: 'mDrive Wizard',
        url: externalAppLinks.mPortal + '/web/index.html#/login?redirect=mdrivewizard',
        icon: 'fa fa-car',
        sortOrder: 27,
        roles: ['User', 'Admin']
      },
      {
        name: 'Inventory Download',
        url: '/inventorydownload',
        icon: 'fa fa-list-alt',
        sortOrder: 30,
        roles: ['User', 'Admin']
      },
      {
        name: 'Partner Mappings',
        url: '/PartnerLevelMappings',
        icon: 'fa fa-list-alt',
        sortOrder: 30,
        roles: ['User', 'Admin', 'PM']
      },
      {
        name: 'ADP Download Test',
        url: '/adpdownloadtest',
        icon: 'fa fa-list-alt',
        sortOrder: 40,
        roles: ['User', 'Admin']
      },
      {
        name: 'mScan Heatmap',
        url: '/mscanheatmap',
        icon: 'fa fa-list-alt',
        sortOrder: 40,
        roles: ['User', 'Admin','PM']
      },
      {
        name: 'Usage Report',
        url: '/usagereport',
        icon: 'fa fa-list-alt',
        sortOrder: 50,
        roles: ['User', 'Admin', 'PM']
      },
      {
        name: 'Error Logs',
        url: '/errorlogs',
        icon: 'fa fa-list-alt',
        sortOrder: 50,
        roles: ['User', 'Admin', 'PM']
      },
      {
        name: 'Full Request Logs',
        url: '/fullrequestlogs',
        icon: 'fa fa-list-alt',
        sortOrder: 50,
        roles: ['User', 'Admin', 'PM']
      },
      {
        name: 'Status Updates',
        url: '/statusupdates',
        icon: 'fa fa-list-alt',
        sortOrder: 50,
        roles: ['Admin']
      },
      {
        name: 'Data Updates',
        url: '/dataupdates',
        icon: 'fa fa-list-alt',
        sortOrder: 50,
        roles: ['User','Admin']
      },
      {
        name: 'User Management',
        url: '/UserManagement',
        icon: 'fa fa-users',
        sortOrder: 500,
        roles: ['Admin']
      }
    ]

    items = items.sort(function (a, b) { return a.sortOrder - b.sortOrder })
    let currentRole = store.state.currentRole

    items = items.filter(function (item) {
      if (item.roles === undefined) {
        return item
      } else {
        if (item.roles.indexOf(currentRole) !== -1) {
          return item
        }
      }
    })
    return items
  }
}



// WEBPACK FOOTER //
// ./src/_nav.js